var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-service-menu__button",class:{
    'is-opened': _vm.store.state.isShoppingPanelVisible
  },attrs:{"title":_vm.model.panelLink && _vm.model.panelLink.title},on:{"click":function($event){$event.preventDefault();return _vm.openShoppingPanel($event)}}},[_c('Icon',{attrs:{"icon":_vm.iconShoppingCart,"size":24,"stroke":"black"}}),(_vm.itemCount > 0)?[_c('span',{staticClass:"c-service-menu__button-badge",class:{
        'is-animating': _vm.isAnimated
      }},[_c('span',[_vm._v(" "+_vm._s(_vm.itemCount)+" ")])])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }